import React from 'react'
import { connect } from 'react-redux'

import IfElse from './ifelse';
import IfComponent from './if';
import { sanitizeHtml } from '../../utils/sanitizeHtml';

const Row = ({ content, html = false, section, index, folder }) => {
    if (content.type === "image") {
        const responsiveStyle = { maxWidth: '100%', height: 'auto' };
        if (html && content.config.src.indexOf('base64') !== -1) {
            const imgSrc = `[@resolveURLByPath]${folder}/${section}_image_${index}[/@resolveURLByPath]`;
            return <img {...content.config} src={imgSrc} style={responsiveStyle}/>
        }
        return <img {...content.config} style={responsiveStyle}/>
    } else if(content.type === "text") {
        return <span dangerouslySetInnerHTML={{__html: sanitizeHtml(content.config.text)}}></span>;
    } else if(content.type === "ifelse") {
        return <IfElse content={content} section={section} parentIndex={index} html={html}/>;
    } else if(content.type === "if") {
        return <IfComponent content={content} section={section} parentIndex={index} html={html}/>;
    } else if (content.type === "mjml") {
        return <span dangerouslySetInnerHTML={{__html: sanitizeHtml(content.config.html || '')}} />;
    } else {
        return <span>Unknown type</span>;
    }
}

const mapStateToProps = (state) => {
    return { 
      folder: state.design.folder
    }
  }
  
  export default connect(
    mapStateToProps
  )(Row)